import React from "react";
import styled from "styled-components";
import { read_timeline_plain_text } from "../../utils/timeline/timeline_normalization";
import { read_timeline_value_label } from "../../utils/timeline/timeline_formatting";

const TimelineWorkCompleted = styled.div`
    display: grid;
    gap: 0.6rem;
    min-width: 0;

    h5, p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

const completedWorkTitles = {
    CONTENT: "Content completed",
    REPORT: "Report completed",
    IDEAS: "Ideas completed",
    PLAN: "Plan completed"
};

export default function Timeline_Work_Completed(props) {
    const workType = read_timeline_value_label(props.event?.data?.issue?.type, "");
    const heading = props.t(completedWorkTitles[workType.toUpperCase()] || "Work completed");
    const title = read_timeline_plain_text(props.event?.data?.issue?.title);
    const description = read_timeline_plain_text(props.event?.data?.issue?.description || props.event?.note);
    const showTitle = title && !["WORK_COMPLETED", workType.toUpperCase(), heading.toUpperCase()].includes(title.toUpperCase());
    const showDescription = description && description !== title && !["WORK_COMPLETED", workType.toUpperCase()].includes(description.toUpperCase());

    return (
        <TimelineWorkCompleted>
            <h5>{heading}{workType && !completedWorkTitles[workType.toUpperCase()] ? <span> · {workType}</span> : null}{props.event?.data?.issue?.issueCode ? <span> · {props.event.data.issue.issueCode}</span> : null}</h5>
            {showTitle ? <p>{title}</p> : null}
            {showDescription ? <p>{description}</p> : null}
        </TimelineWorkCompleted>
    );
}

export { Timeline_Work_Completed };
